import TriangleRuler from '../src/TriangleRuler';
export default TriangleRuler;
